import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("cookie_consent")) setShow(true); }, []);
  const decide = (v) => { localStorage.setItem("cookie_consent", v); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-[60] card-lux p-4 shadow-xl" data-testid="cookie-consent">
      <p className="text-sm text-stone-600">Nous utilisons des cookies nécessaires au fonctionnement du site. Vous pouvez accepter les cookies optionnels (mesure d'audience) ou les refuser.</p>
      <div className="flex gap-2 mt-3">
        <Button size="sm" variant="outline" className="rounded-full flex-1" onClick={() => decide("necessary")} data-testid="cookie-refuse">Nécessaires uniquement</Button>
        <Button size="sm" className="rounded-full flex-1" onClick={() => decide("all")} data-testid="cookie-accept">Tout accepter</Button>
      </div>
    </div>
  );
}
